<template>
  <div id="page">
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="旧密码" prop="password1">
        <a-input v-model="form.password" type="password" />
      </a-form-model-item>
      <a-form-model-item label="新密码" prop="password1">
        <a-input v-model="form.password1" type="password" />
      </a-form-model-item>
      <a-form-model-item label="确认新密码" prop="password2">
        <a-input v-model="form.password2" type="password" />
      </a-form-model-item>
      <a-button type="primary" @click="restPwd" class="button-right"> 重置密码 </a-button>
    </a-form-model>
  </div>
</template>

<script>
import util from '../../util.js'
export default {
  data() {
    const checkPwd2 = (rule, value, callback) => {
      if (value !== this.form.password1) {
        return callback(new Error('两次密码不一致'))
      } else {
        return callback()
      }
    }
    return {
      form: { password: '', password1: '', password2: '' },
      rules: {
        password: [
          { required: true, message: '请输旧入密码', trigger: 'blur' }
        ],
        password1: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: util.checkPwd, tirgger: 'change' }
        ],
        password2: [
          { required: true, message: '请重新输入新密码', trigger: 'blur' },
          { validator: checkPwd2, tirgger: 'change' }
        ]
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 18 }
    }
  },
  methods: {
    restPwd() {
      console.log(1)
    }
  }
}
</script>

<style>
#page{
  padding: 1rem 2rem 1rem 2rem
}
.button-right{
  float: right;
}
</style>
